"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaywallModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
/**
 * Component capable of rendering the `Paywall's` contents.
 */
let PaywallModuleUi = class PaywallModuleUi extends ui_1.AbstractModuleUi {
};
PaywallModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'AdBannerModuleUi',
        template: '<span class="paywall"></span>'
    })
], PaywallModuleUi);
exports.PaywallModuleUi = PaywallModuleUi;
//# sourceMappingURL=Paywall.ui.js.map